module.exports = __webpack_public_path__ + "img/ic_take-video.d2e9ffb2.png";